import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { ITongHopKyRequest } from "../../../model/request/tong-hop-diem/ITongHopKyRequest";
import { ITongHopDiemResponse } from "../../../model/response/tong-hop-diem/ITongHopDiemResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTongHopKyActionsObj= {
    LOAD_START: {} as ITongHopKyRequest,
    LOAD_SUCCESS: {} as ITongHopDiemResponse,
    LOAD_ERROR: "",

    CHANGE_FILTER: {} as ITongHopKyRequest,
 
    CHANGED_FOCUSED_VALUE_LOP: {} as ITreeviewLopFocusedValue,
}

export const eTongHopKyActionIds =  generateActionTypeIds(eTongHopKyActionsObj, "TONG_HOP_KY");
export type ITongHopKyActionTypes = IGenericActionType<typeof eTongHopKyActionsObj, "TONG_HOP_KY">;